export const IMAGE_REMOTE_HOSTS = [
  "drive.google.com",
  "ydszzxycrdxlqevuysxb.supabase.co",
  "szoumlqrcmdhbxvuwpva.supabase.co",
  "assets.enrichlayer.com",
  "lh3.googleusercontent.com",
  "media.mixrank.com",
] as const;
